import React from "react";
import { Link } from "react-router-dom"; // Import Link
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="site-footer"> {/* Added a general class for the footer element */}
      <div className="footer-main"> {/* Removed bg-light and py-4, will control via CSS */}
        <div className="container">
          <div className="row">
            {/* Company Section */}
            <div className="col-md-3 footer-column">
              <h5 className="footer-header">Bazarc</h5>
              <hr className="footer-line" />
              <ul className="list-unstyled footer-links-list">
                <li>
                  <Link to="/" className="footer-link"> {/* Use Link */}
                    Domov
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="footer-link"> {/* Assuming /about is a route */}
                    O nas
                  </Link>
                </li>
                <li>
                  <Link to="/mission" className="footer-link"> {/* Assuming /mission is a route */}
                    Misija in vizija
                  </Link>
                </li>
              </ul>
            </div>
            {/* How to Sell Fast Section */}
            <div className="col-md-3 footer-column">
              <h5 className="footer-header">Kako hitro prodati</h5>
              <hr className="footer-line" />
              <ul className="list-unstyled footer-links-list">
                <li>
                  <Link to="/selling-tips" className="footer-link"> {/* Example route */}
                    Nasveti za hitro prodajo
                  </Link>
                </li>
                {/* Add other links here if they are actual routes */}
              </ul>
            </div>
            {/* Information Section */}
            <div className="col-md-3 footer-column">
              <h5 className="footer-header">Informacije</h5>
              <hr className="footer-line" />
              <ul className="list-unstyled footer-links-list">
                <li>
                  <Link to="/faq" className="footer-link"> {/* Example route */}
                    Pogosta vprašanja
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="footer-link"> {/* Example route */}
                    Pogoji in določila
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="footer-link"> {/* Example route */}
                    Politika zasebnosti
                  </Link>
                </li>
                <li>
                  <Link to="/cookies" className="footer-link"> {/* Example route */}
                    Politika piškotkov
                  </Link>
                </li>
              </ul>
            </div>
            {/* Help & Support Section */}
            <div className="col-md-3 footer-column">
              <h5 className="footer-header">Pomoč in podpora</h5>
              <hr className="footer-line" />
              <ul className="list-unstyled footer-links-list">
                <li>
                  <Link to="/contact" className="footer-link"> {/* Example route */}
                    Kontaktiraj nas
                  </Link>
                </li>
                <li>
                  <Link to="/feedback" className="footer-link"> {/* Example route */}
                    Podaj mnenje
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom"> {/* Removed classes, control via CSS */}
        <p className="mb-0">© 2025 Bazarc. Vse pravice pridržane.</p>
      </div>
    </footer>
  );
};

export default Footer;